/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Website_HintInputs */

const cs_blog_website_hint = /** @type {(inputs: Blog_Website_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikované články načítá váš veřejný web—stejně jako inzeráty a profily makléřů. CRM uchovává obsah, web ho zobrazí.`)
};

const en_blog_website_hint = /** @type {(inputs: Blog_Website_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published articles are loaded by your public website—the same feed as listings and agent profiles. The CRM stores content; your site renders it.`)
};

/**
* | output |
* | --- |
* | "Published articles are loaded by your public website—the same feed as listings and agent profiles. The CRM stores content; your site renders it." |
*
* @param {Blog_Website_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_website_hint = /** @type {((inputs?: Blog_Website_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Website_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_website_hint(inputs)
	return cs_blog_website_hint(inputs)
});